// @ts-nocheck
import React from "react";
const PopupGiftTopup = (props) => {
  const { giftData } = props;

  const onTopup = () => {
    props.onTopupMobile();
    document.body.classList.remove("modal-open");
  };
  const handleConfirm = () => {
    props?.clickAction();
    localStorage.removeItem("rewardData");
  };

  // const checkImgGift = () => {
  //   let img = "";
  //   switch (props?.giftType) {
  //     case "Physical":
  //       img = gift1;
  //       break;
  //     case "TopUpUrbox":
  //       img = gift2;
  //       break;

  //     case "Greeting":
  //       img = Lucky;
  //       break;

  //     default:
  //       break;
  //   }
  //   return img;
  // };

  return (
    <>
      <div className="popup-overlay modal-topup">
        <div className="popup-warp">
          <div className="popup-inner">
            <div className="content-popup">
              <h5>
                Chúc mừng !
                <br />
                Bạn đã nhận được
              </h5>

              <>
                <img
                  className="img-animation fadeIn"
                  src="assets/img/colorful.svg"
                  alt="200.png"
                />
                {/* <img
                  className="img-gift"
                  src={props?.giftType?.extraInfo?.imageUrl}
                  alt="200.png"
                /> */}
                <img
                  className="img-gift"
                  src={giftData?.giftImage}
                  alt="200.png"
                />
              </>
              {/* <h3 className="name-gift">{props?.giftType?.extraInfo?.name}</h3> */}
              <h3 className="name-gift">{giftData?.giftName}</h3>
              <p>Vui lòng kiểm tra tin nhắn SMS trên điện thoại để nhận quà</p>

              <div className="btn-wrapper btn-center">
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={handleConfirm}
                >
                  XÁC NHẬN
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupGiftTopup;
